export const environment = {
  production: true,
  buildId: '2572581534917731',
  configFile: 'config.json',
};
